import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/32.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Zalało Tarszewo"     
        question="W którą stronę się kierujesz?" 
            audio={audio}
        answers={{
            ans1: "W stronę miasteczka.",
            ans2: "W stronę Warty.",    
        }}
        links={{
            link1: PAGES.p59,
            link2: PAGES.p60,
        }}
        content={
            <div>
                <p>
                Kiedy wychodzisz rano przed dom z rudy darniowej, widzisz, że rzeka wylała. Dom stoi na wzgórzu, a wokół widać lśniącą taflę wody, z której tu i ówdzie wystają wysepki.
                </p>
                <ul>
                    <li>
                    Emilu, zalało nas! – krzyczysz do Emila, który wychodzi z chaty. Biegasz dookoła domu, oglądając wielką wodę.
                    </li>
                </ul>
            </div>
        }
        />
        
            );
}